const educationList = [
  {
    id: "education-1",
    icon: "./ainshams.png",
    title: "Master of Science in Computer and Information Sciences",
    degree: "Scientific Computing Department",
    duration: "March 2023 – Present",
    location: "Cairo, Egypt",
    content1: "Ain Shams University",
  },
  {
    id: "education-2",
    icon: "./uottawa.png",
    title: "Master of Engineering in Electrical and Computer Engineering",
    degree: "Artificial Intelligence and Data Science",
    duration: "May 2022 – January 2023",
    location: "Ottawa, Canada",
    content1: "University of Ottawa",
    content2: "Grade: A+ Excellent",
    content3: "Relevant coursework: Machine Learning, Data Science, Natural Language Processing (NLP), Smart Cities, Cloud, AI for Cybersecurity, and Computer Vision.",
  },
  {
    id: "education-3",
    icon: "./ainshams.png",
    title: "Bachelor of Science in Computer and Information Sciences",
    degree: "Scientific Computing Department",
    duration: "September 2017 – July 2021",
    location: "Cairo, Egypt",
    content1: "Ain Shams University",
    content2: "Graduated with a Very Good grade and Excellent grade in the graduation project.",
  },
];

export default educationList;
